import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const extractList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
};

export const getRoles = () =>
  axiosInstance.get(`${ADMIN_API_URL}/roles`, {
    headers: authHeaders(),
  });

export const getPermissions = () =>
  axiosInstance.get(`${ADMIN_API_URL}/roles/permissions`, {
    headers: authHeaders(),
  });

export const getRolePermissions = (roleId) =>
  axiosInstance.get(
    `${ADMIN_API_URL}/roles-permissions/role/${roleId}/permissions`,
    {
      headers: authHeaders(),
    },
  );

export const createRoleRequest = (roleData) =>
  axiosInstance.post(`${ADMIN_API_URL}/roles/add`, roleData, {
    headers: authHeaders(),
  });

export const updateRoleRequest = (roleId, roleData) =>
  axiosInstance.put(`${ADMIN_API_URL}/roles/edit/${roleId}`, roleData, {
    headers: authHeaders(),
  });

export const deleteRoleRequest = (roleId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/roles/delete/${roleId}`, {
    headers: authHeaders(),
  });

export const assignPermissionsRequest = (roleId, permissionIds) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/roles-permissions/assign-multiple-permissions`,
    {
      role_id: Number(roleId),
      permission_ids: permissionIds,
    },
    {
      headers: authHeaders(),
    },
  );
